import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiSystemSettingsConstants } from "../../constants/api-constants/api-system-settings.constants";
import { AppConfig } from "../../../app.config";
import { firstValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
let SystemSettingService = class SystemSettingService {
    http;
    appConfig;
    router;
    systemSettings;
    maintenanceModeEnabled = false;
    maintenanceAcknowledged = false;
    constructor(http, appConfig, router) {
        this.http = http;
        this.appConfig = appConfig;
        this.router = router;
    }
    async loadSettings() {
        this.maintenanceAcknowledged = false;
        const httpParams = new HttpParams().set("filters", "key eq 'maintenance_mode'");
        try {
            this.systemSettings = await firstValueFrom(this.http.get(`${ApiSystemSettingsConstants.URL}/0/${ApiSystemSettingsConstants.FUNCTION_GET_PUBLIC_SYSTEM_SETTINGS}`, { params: httpParams }));
        }
        catch (err) {
            console.error(`${ApiSystemSettingsConstants.URL}`, httpParams, err);
            this.systemSettings.value = [];
        }
    }
    get(key) {
        return this.systemSettings.value.find(x => x.key === key)?.value;
    }
    updateMaintenanceMode(toggle) {
        let setting = this.systemSettings.value.find(x => x.key === "maintenance_mode");
        if (setting) {
            const settingID = setting.id;
            var updatedSetting = {
                value: JSON.stringify({ enabled: toggle })
            };
            setting.value = JSON.stringify({ enabled: toggle });
            try {
                return this.http.patch(`${ApiSystemSettingsConstants.URL}/${settingID}`, updatedSetting)
                    .pipe(map(response => {
                    return response;
                }));
            }
            catch (err) {
                console.error(`${ApiSystemSettingsConstants.URL}`, err);
                this.loadSettings();
            }
        }
        else {
            setting = { id: 0, key: "maintenance_mode", value: JSON.stringify({ enabled: toggle }) };
            try {
                return this.http.post(`${ApiSystemSettingsConstants.URL}`, setting)
                    .pipe(map(response => {
                    return response;
                }));
            }
            catch (err) {
                console.error(`${ApiSystemSettingsConstants.URL}`, err);
                this.loadSettings();
            }
        }
    }
    isMaintenanceModeEnabled() {
        if (this.systemSettings !== null && this.systemSettings !== undefined && this.systemSettings.value !== null) {
            const maintenanceMode = this.systemSettings.value.find(x => x.key === "maintenance_mode")?.value;
            if (maintenanceMode !== null && maintenanceMode !== undefined) {
                this.maintenanceModeEnabled = JSON.parse(maintenanceMode).enabled;
            }
            return this.maintenanceModeEnabled;
        }
        else {
            return false;
        }
    }
    setMaintenanceAcknowledged() {
        this.maintenanceAcknowledged = true;
    }
    getMaintenanceAcknowledged() {
        return this.maintenanceAcknowledged;
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppConfig },
        { type: Router }
    ];
};
SystemSettingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SystemSettingService);
export { SystemSettingService };
